export default {"src":"/_next/static/media/client-auth-background.64efb3b1.svg","height":900,"width":1440};